<template>
  <div class="supported-networks-page">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'supported-networks-page',
}
</script>

<style scoped>

</style>
